import React, { useState, useEffect } from "react";
import "./Sessions.css";
import { useAuth } from "../../AuthContext";
import useSessions from "../../Hooks/useSessions";
import { FaClock } from "react-icons/fa";
import Loading from "../Loading/Loading";

export default function Sessions({ selectedDate }) {
  const { userToken } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const { sessions } = useSessions(userToken, selectedDate, setIsLoading);
  const [activeSessionId, setActiveSessionId] = useState(null);

  useEffect(() => {
    if (sessions.length > 0) {
      setActiveSessionId(sessions[0].id);
    }
  }, [sessions]);

  const handleSessionClick = (sessionId) => {
    setActiveSessionId(sessionId);
  };
  return (
    <div className="sessionsWrapper centeredFlex">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {sessions.length > 0 ? (
            <div className="sessionsInner centeredFlex">
              {sessions
                .filter((session) => session.id === activeSessionId)
                .map((session) => (
                  <div key={session.id} className="activeSession centeredFlex">
                    <div className="activeSessionDate">
                      {session.date.day} {session.date.month}{" "}
                      {session.date.year}
                    </div>
                    <div className="activeSessionTime">{session.date.time}</div>
                    <div className="activeSessionTitle">
                      {session.product.name}
                    </div>
                    <div className="activeSessionDuration">
                      {session.duration}{" "}
                      <FaClock className="activeSessionIcon" />
                    </div>
                    {!session.locked && session.link !== null && (
                      <a href={session.link} className="activeSessionBtn link">
                        ورود به کلاس
                      </a>
                    )}
                  </div>
                ))}
              <div className="allSessions centeredFlex scroll">
                {sessions.map((session) => (
                  <div
                    key={session.id}
                    className="session centeredFlex"
                    style={
                      session.product.type === "FITNESS"
                        ? { backgroundColor: "#FF4545" }
                        : session.product.type === "YOGA"
                        ? { backgroundColor: "#4AA366" }
                        : session.product.type === "PILATES"
                        ? { backgroundColor: "#FF842C" }
                        : { backgroundColor: "#94CDFD" }
                    }
                    onClick={() => handleSessionClick(session.id)}
                  >
                    <p>
                      {session.product.name.length > 12
                        ? session.product.name.slice(0, 12) + "..."
                        : session.product.name}
                    </p>
                    <p>{session.date.time}</p>
                    <p>
                      {session.date.day} {session.date.month}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <span className="sessionNotFound">جلسه ای یافت نشد</span>
          )}
        </>
      )}
    </div>
  );
}
